import { render, staticRenderFns } from "./TalentPoolIcon.vue?vue&type=template&id=4d4d424e&"
import script from "./TalentPoolIcon.vue?vue&type=script&lang=ts&"
export * from "./TalentPoolIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./TalentPoolIcon.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports